import React, { Component, Suspense } from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { connect } from "react-redux";
import SideBar from "./nav/NavBar";
import { Route, Switch } from "react-router-dom";
import ReduxToastr from "react-redux-toastr";
import "react-toastify/dist/ReactToastify.css";
import Footer from "./common/Footer";
import Login from "./login/Login";
import NotFoundPage from "./common/NotFoundPage";
import User from "./user";
import Dashboard from "./dashboard";
import DashboardWithGraph from "./dashboard/DashboardWithGraph";
import { Loader } from "../../src/components/common/Loader";
import PartMaster from "./masters/part-master";
import UOMMaster from "./masters/uom-master";
import RowMaterialMaster from "./masters/material-master";
import PlantMaster from "./masters/plant-master/index";
import SupplierMaster from "./masters/supplier-master/VendorListing";
import BOPMaster from "./masters/bop-master";
import FuelMaster from "./masters/fuel-master";
import FreightMaster from "./masters/freight-master";
import LabourListing from "./masters/labour-master/LabourListing";
import OverheadProfit from "./masters/overhead-profit-master";
import InterestRate from "./masters/interest-rate-master/InterestRateListing";
import MachineMaster from "./masters/machine-master";
import ReasonListing from "./masters/reason-master/ReasonListing";
import VolumeListing from "./masters/volume-master/VolumeListing";
import ClientMaster from "./masters/client-master/AddClient";
import ExchangeRateListing from "./masters/exchange-rate-master/ExchangeRateListing";
import TaxListing from "./masters/tax-master/TaxListing";
import LeftMenu from "./nav/Leftsidemenu";
import Breadcrumb from "./nav/Breadcrumb";
import CostingRoutes from "./costing/Routes";
import AuditTrail from "./HavellsEmployeePortal/AuditTrail/AuditTrail";
import {
  showUserData,
  TokenAPI,
  AutoSignin,
} from "../actions/auth/AuthActions";
import AuthMiddleware from "../AuthMiddleware";
import {
  BOP,
  DASHBOARD,
  FREIGHT,
  FUEL_AND_POWER,
  INTEREST_RATE,
  LABOUR,
  MACHINE,
  OPERATION,
  OVERHEAD_AND_PROFIT,
  PART,
  PLANT,
  RAW_MATERIAL,
  UOM,
  USER,
  VENDOR,
  REASON,
  VOLUME,
  CLIENT,
  EXCHANGE_RATE,
  TAX,
  COSTING_PATH,
  APPROVAL_LISTING_PATH,
  COSTING_BREAKUP_DETAILS_REPORT,
  APPROVAL_APP,
  APPROVAL_SUMMARY_PATH,
  COSTING_BULK_UPLOAD,
  COSTING_SUMMARY_,
  COSTING_SUMMARY,
  Simulation_Page,
  Simulation_Upload,
  API,
  DASHBOARDWITHGRAPH_PATH,
  SIMULATION_APPROVAL_SUMMARY_PATH,
  DASHBOARD_PATH,
  DASHBOARD_PATH_SECOND,
  SHEET_METAL,
  SIMULATION_PATH,
  SIMULATION_HISTORY_PATH,
  USER_PATH,
  RFQ_LISTING,
  AUCTION_LISTING,
  RFQ,
  COST_RATIO_REPORT,
  BUDGETING,
  NFR_LISTING,
  NFR,
  MASTER_BENCHMARK_REPORT,
  COST_MOVEMENT_REPORT,
  SUPPLIER_CONTRIBUTION_REPORT,
  SALE_PROVISION_REPORT,
  PURCHASE_PROVISION_REPORT,
  CUSTOMER_POAM_REPORT,
  HEAD_WISE_COSTING_GOT_GIVEN,
  PLANT_HEAD_WISE,
  PRODUCT_ROLLOUT,
  OUTSOURCING,
  RESET_PASSWORD,
  FORGET_PASSWORD,
  NEW_REQUEST_HISTORY,
  ALL_SUPPLIER,
  SUPPLIER_REQUEST_HISTORY,
  VIEW_NEW_REQUEST_HISTORY,
  ADD_VENDOR_NEED_FORM,
  NON_REGISTERED_SUPPLIER_DETAILS,
  VENDOR_NEED_FORM,
  lOGIN_AUDIT,
  NFR_INSIGHT_DETAILS,
  MASTER_COST_MOVEMENT_REPORT,
  INSIGHT_SIMULATION_REPORT,
  BUSINESS_TYPE_LIST,
  ADD_SPECIALIZATION_LIST,
  ADD_BUSINESS_TYPE,
  ASSESMENT_MASTER_LISTING,
  PENDING_FOR_APPROVAL_URL,
  ADD_SUPPLIER,
  VIEW_SUPPLIER_VENDOR_NEED_FORM,
  ADD_ASSESMENT_QUESTION,
  SPECIALIZATION_LIST,
  ADD_AUDIT_PERSON,
  ASSIGN_CFT,
  NSA_LIST,
  PENDING_AUDIT_LIST,
  ALL_SUPPLIER_PAGE,
  NEW_SUPPLIER_REQUEST,
  ALL_NEED_FORM,
  PENDING_FOR_APPROVAL_PAGE,
  NSA_LIST_PAGE,
  PENDING_AUDIT_LIST_PAGE,
  BUISNESS_TYPE_PAGE,
  AUDIT_PERSON,
  LEGAL_DOCUMENT_PAGE,
  SPECIALIZATION_PAGE,
  ASSESSMENT_PAGE,
  NEW_SUPPLIER_NEED_FORM,
  PENDING_FOR_APPROVAL_KYS2_LIST,
  ACCOUNT_GROUP_MASTER,
  SUPPLIER_APPROVAL_SUMMARY,
  VENDOR_MANAGEMENT,
  APPROVAL_LISTING,
  INITIATE_UNBLOCKING,
  SUPPLIER_MANAGEMENT,
  lOGIN_AUDITS,
  ADD_PAYMENT_TERMS,
  EMAIL_TRACKING,
  SOC_CODE_MASTER_ADDITIONAL,
  SNF_APPROVAL_WORK_FLOW,
  PENDING_FOR_APPROVAL_SUPPLIER,
  LPS,
  SUPPLIER_CERTIFICATE,
  EXCEPTION_APPROVAL_LIST,
  EXCEPTION_APPROVAL_MENU,
  ACCOUNT_GROUP_MAPPING_MASTER,
  RECONCILIATION_MASTER,
  INDEXATION,
  COMPANY_CODE_MASTER,
  MASTER_UPDATE_REQUESTS,
  MASTER_UPDATE,
  VENDOR_UNBLOCKING_REQUEST_LIST,
  ANNUAL_KYS_UPDATES,
  ANNUAL_KYS_UPDATES_LIST,
  MASTER_UPDATE_REQUEST_LIST,
  COSTING_DETAIL,
  ADD_AUCTION,
  REPOSITORY_DASHBOARD,
  SUPPLIER_ONBOARDING_DASHBOARD_REPORT,
  DETAIL_TRACKING_REPORT,
  DETAIL_TRACKING_REPORT_L1,
  DETAIL_TRACKING_REPORT_L2,
  APPLICATION_TRACKER_DATES_REPORT,
  EXCEPTION_DASHBOARD,
  EXCEPTION_DRILLDOWN,
  PENDING_APPROVAL_DRILLDOWN_REPORT,
  NSA_DRILLDOWN_REPORT,
  KYS_UPDATES_DASHBOARD,
  MASTER_UPDATE_DASHBOARD,
  SUPPLIER_UNBLOCKING_DASHBOARD,
  MASTER_UPDATE_DRILLDOWN,
  VENDOR_UNBLOCKING,
  ANNUAL_KYS_REQUEST_LIST,
  KYS_UPDATES_DRILLDOWN,
  UPDATE_UNBLOCKING_REQUEST,
  MASTER_UPDATE_REQUEST_DETAIL_VIEW,
  ANNUAL_KYS_REQUEST,
  ANUUAL_KYS_REQUEST_DETAIL,
  COSTING_BULKUPLOAD,
} from "../config/constants";
import ApprovalSummary from "./costing/components/approval/ApprovalSummary";
import CostingSummaryBulkUpload from "./costing/components/CostingSummaryBulkUpload";
import SimulationUpload from "./simulation/components/SimulationUpload";
import { userDetails } from "../helper/auth";
import { formatLoginResult } from "../helper/ApiResponse";
import axios from "axios";
import CostingDetailReport from "./report/components/CostingDetailReport";
import SimulationApprovalSummary from "./simulation/components/SimulationApprovalSummary";
import OperationsMaster from "./masters/operation/index";
import CostingBenchmarkReport from "./report/components/CostingBenchmarkReport";
import ToasterBoXWrapper from "./common/ToasterBoXWrapper";
import SimulationInsights from "./report/components/SimulationInsights";
import SimulationRoutes from "./simulation/Routes";
import CommonApproval from "./masters/material-master/CommonApproval";
import RfqListing from "./rfq/RfqListing";
import CostMovementReport from "./report/components/CostMovementReport/CostMovementReport";
import CostRatioReport from "./report/components/CostRatioReport/CostRatioReport";
import SupplierContributionReport from "./report/components/SupplierContribution";
import NfrTabs from "./masters/nfr";
import SaleProvisionReport from "./report/components/SaleProvisionReport/SaleProvisionReport";
import PurchaseProvisionReport from "./report/components/PurchaseProvisionReport/PurchaseProvisionReport";
import CustomerPoamSummaryReport from "./report/components/CustomerPoamSummaryReport/CustomerPoamSummaryReport";
import HeadWiseCostingGotGiven from "./report/components/HeadwiseCostingGotGiven/HeadWiseCostingGotGiven";
import MasterCostMovement from "./report/components/CostMovementByMaster/MasterCostMovement";
import BudgetMaster from "./masters/budget-master";
import GotGivenReport from "./report/components/GotGivenReport/GotGivenReport";
import PipdReport from "./report/components/PIPDReport/PipdReport";
import PlantWiseCostingGotGiven from "./report/components/PlantWiseCostingGotGiven/PlantWiseCostingGotGiven";
import ProductRollout from "./report/components/ProductRollout";
import OutsourcingListing from "./masters/outsourcing-master/OutsourcingListing";
import CostingForm from "./costing/components";
import SimulationForm from "./simulation/components";
import ResetPassword from "./login/ResetPassword";
import LoginAudit from "./audit/LoginAudit";
import SAPDetailList from "./masters/sap-detail/SAPDetailList";
import NFRInsightsReport from "./report/components/NFRInsightReportFolder/NFRInsightReport";
import ViewNewRequestHistory from "./HavellsEmployeePortal/supplierNewRequestHistory/ViewNewRequestHistory";
import AddVendorNeed from "./HavellsEmployeePortal/VendorNeedForm/AddVendorNeed";
import ViewSupplierDetails from "./HavellsEmployeePortal/VendorNeedForm/ViewSupplierDetails";
import VendorManagement from "./vendorManagement/index";
import InitiateUnblocking from "./vendorManagement/InitiateUnblocking";
import LpsRatingListing from "./vendorManagement/LpsRatingLisitng";
import VendorMaster from "./masters/supplier-master";
import AssesmentForm from "./HavellsEmployeePortal/AssesmentForm/index";
import AssignCfts from "./HavellsEmployeePortal/NsaAudit/NSA/NsaTabs/AssignCfts/AssignCfts";
import SupplierOnboardingPermission from "./HavellsEmployeePortal/supplierListAll";
import VendorOnboaringPermission from "./HavellsEmployeePortal/VendorNeedList";
import BuisnessTypePermission from "./HavellsEmployeePortal/EmployeeBusinessType/business-type-list";
import AuditListing from "./HavellsEmployeePortal/AuditEmployee";
import LegalDocument from "./HavellsEmployeePortal/LegalDocument/legalDocumentList";
import Specialization from "./HavellsEmployeePortal/SpecializationList/specializationList";
import Assesment from "./HavellsEmployeePortal/AssesmentMaster";
import PendingForApprovalKys2List from "./HavellsEmployeePortal/L1Approver/Level1Approver/Level1Tabs/PendingForApprovalKys2List/index";
import ExceptionFlowApproval from "./HavellsEmployeePortal/ExceptionFlowApprovalMaster/ExceptionFlowApproval";
import AccountGroupMaster from "./HavellsEmployeePortal/AccountGroupMaster";
import MasterUpdateRequests from "./HavellsEmployeePortal/MasterUpdateRequests";
import AnnualKysRequests from "./HavellsEmployeePortal/AnnualKysRequests";
import AnnualKYSUpdates from "./HavellsEmployeePortal/AnnualKYSUpdates";
import PaymentTermsMaster from "./HavellsEmployeePortal/PaymentTermMaster";
import PendingList from "./HavellsEmployeePortal/VendorNeedList/PendingList";
import EmailTrackMaster from "./HavellsEmployeePortal/EmailTrackingMaster";
import SocListMaster from "./HavellsEmployeePortal/SocMasterListing";
import VendorClassificationListing from "./vendorManagement/VendorClassificationListing";
import ViewApprovalSummarySnf from "./HavellsEmployeePortal/L1Approver/Level1Approver/Level1Tabs/VendorNeedApproval/VendorNeedTabs/ViewApprovalSummarySnf";
import SupplierCertificateMaster from "./HavellsEmployeePortal/SupplierCertificateMaster";
import AccountGroupMappingListMaster from "./HavellsEmployeePortal/AccountGroupMappingMaster";
import ReconciliationListMaster from "./HavellsEmployeePortal/ReconciliationAccountMaster";
import NsaListingPermission from "./HavellsEmployeePortal/NsaAudit/NSA/NsaListing";
import PendingAuditList from "./HavellsEmployeePortal/NsaAudit/PendingAuditList";
import ExceptionApprovalPermission from "./HavellsEmployeePortal/ExceptionalApproval";
import SupplierRequestHistoryList from "./HavellsEmployeePortal/supplierNewRequestHistory/supplierRequestHistoryList";
import PendingListKy2 from "./HavellsEmployeePortal/L1Approver/Level1Approver/Level1Tabs/PendingForApprovalKys2List/index";
import CompanyCodeListMaster from "./HavellsEmployeePortal/CompanyCodeMaster";
import MasterUpdateRequestsDetail from "./HavellsEmployeePortal/MasterUpdateRequests/MasterUpdateRequestsDetail/index";
import AnnualKysRequestsDetail from "./HavellsEmployeePortal/AnnualKysRequests/AnnualKysRequestsDetail/index";
import Indexation from './masters/indexation'

import AuctionIndex from "./rfqAuction/AuctionIndex";
import AddAuction from "./rfqAuction/AddAuction";
import RepositoryReportDashboard from "./HavellsEmployeePortal/HavellsReport/RepositoryReportDashboard";
import SupplierOnboardingDashboardReport from "./HavellsEmployeePortal/HavellsReport/SupplierOnboardingDashboardReport";
import DetailTrackingReportL1 from "./HavellsEmployeePortal/HavellsReport/DetailTrackingReportL1";
import DetailTrackingReportL2 from "./HavellsEmployeePortal/HavellsReport/DetailTrackingReportL2";
import ApplicationTrackerDatesReport from "./HavellsEmployeePortal/HavellsReport/ApplicationTrackerDatesReport";
import ExceptionDashboardReport from "./HavellsEmployeePortal/HavellsReport/ExceptionDashboardReport";
import ExceptionDrillDownReport from "./HavellsEmployeePortal/HavellsReport/ExceptionDrillDownReport";
import PendingApprovalDrillDownReport from "./HavellsEmployeePortal/HavellsReport/PendingApprovalDrillDownReport";
import NSADrillDownReport from "./HavellsEmployeePortal/HavellsReport/NSADrillDownReport";
import KYSUpdateDashboardReport from "./HavellsEmployeePortal/HavellsReport/KYSUpdateDashboardReport";
import MasterUpdateDashboardReport from "./HavellsEmployeePortal/HavellsReport/MasterUpdateDashboardReport";
import SupplierUnblockingDashboardReport from "./HavellsEmployeePortal/HavellsReport/SupplierUnblockingDashboardReport";
import MasterUpdateDrillDownReport from "./HavellsEmployeePortal/HavellsReport/MasterUpdateDrillDownReport";
import KYSUpdateDrillDownReport from "./HavellsEmployeePortal/HavellsReport/KYSUpdateDrillDownReport";
import AddUnblockingRequest from "./HavellsEmployeePortal/supplierListAll/AddUnblockingRequest";
import SupplierUnblockingRequest from "./HavellsEmployeePortal/SupplierUnblockingRequest";
import AuditTrailTab from "./HavellsEmployeePortal/AuditTrail";
import setupAxiosInterceptors from "../axiosInterceptor";

const CustomHeader = {
  "Content-Type": "application/x-www-form-urlencoded",
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Credentials": "true",
  Authorization: `Bearer NRIsJAXFS-IgPMtfW05J1EiTwhv4z37BnFCk2TynvAdVYMuBIal7dTYyfboxRFjvPJ1zPl4r4LfQJ8_1fKDnSxTmGmThhl6YabKHaGvzp2WDQ7P0wFZs2wW10Mcmkt4Xb4ybDGzwSLt6fwRuI1uGNRuyNMxKQz-s533rIF5Qx08vwumo5ogN5x_oyi__b4KXJWbUU_0qLaJGLwISEf4o3_4CPBoP6Gv_tAGIO1W250SzOF3zwYpTxi8LwghOtQse`,
  "Access-From": "WEB",
  "Api-Key": `${process.env.REACT_APP_API_KEY}`,
};

const Detail = userDetails();


class Main extends Component {
  constructor(props) {
    super(props);
    this.child = React.createRef();
    this.state = {
      visibelPageNotFound: false,
      breadcrumbTrail: {},
      isLoader: false,
    };
  }

  UNSAFE_componentWillMount() {
    if (this?.props?.location?.search) {
      if (reactLocalStorage.getObject("isUserLoggedIn") === true) return false;
      this.setState({ isLoader: true });
      const queryParams = new URLSearchParams(this.props.location.search);
      const token = queryParams.get("token");
      const username = queryParams.get("username");

      let reqParams = {
        Token: token,
        UserName: username,
      };
      if (
        this.props.location.pathname === RESET_PASSWORD ||
        this.props.location.pathname === FORGET_PASSWORD
      ) {
        this.setState({ isLoader: false });
      } else {
        this.props.AutoSignin(reqParams, (res) => {
          if (res && res.status === 200) {
            let userDetail = formatLoginResult(res.data.Data);
            localStorage.setItem("userDetail", JSON.stringify(userDetail));
            //MIL DEPARTMENT RELATED CHANGE
            // let departmentList = ''
            // const dept = userDetail && userDetail.Department.map((item) => {
            //   if (item.DepartmentName === 'Corporate' || item.DepartmentName === 'Administration') {
            //     return ''
            //   } else {
            //     return item.DepartmentCode
            //   }

            // })
            // departmentList = dept.join(',')
            // localStorage.setItem("userDetail", JSON.stringify(userDetail))
            // reactLocalStorage.setObject("departmentList", departmentList);
            this.props.logUserIn();
            setTimeout(() => {
              this.setState({ isLoader: false });
              window.location.replace("/");
            }, 1000);
          }
        });
      }
    }
  }

  /**
   * @method handlePageNotFound
   * @description Handle the page not found when the url entered is incorrect.
   */
  handlePageNotFound = () => {
    this.setState({
      visibelPageNotFound: true,
    });
  };

  /**
   * @method hidePageNotFound
   * @description Handle the page not found when the url entered is incorrect.
   */
  hidePageNotFound = () => {
    this.setState({
      visibelPageNotFound: false,
    });
  };

  /**
   * @method handleUserData
   * @description Method used when refreshing browser then consistency of logged in user.
   */
  handleUserData = () => {
    let userData = JSON.parse(localStorage.getItem("userDetail"));
    this.props.showUserData(userData);
  };

  setSidebarLinks = (linkText) => {
    this.setState({
      sidebarLinks: linkText,
    });
  };

  render() {
    if (Detail && Object.keys(Detail)?.length > 0){
    setupAxiosInterceptors();
    }
    const { location } = this.props;
    let isLogin = false;
    let checkLogin = reactLocalStorage.getObject("isUserLoggedIn");
    reactLocalStorage.set("location", location.pathname);
    if (typeof checkLogin == "object") {
      isLogin = false;
    }
    if (checkLogin === true) {
      isLogin = true;
    } else {
      isLogin = false;
    }

    const fullSizeClass =
      location.pathname === COSTING_PATH ||
        /*   location.pathname === APPROVAL_LISTING_PATH ||
                location.pathname === APPROVAL_SUMMARY_PATH ||
                location.pathname === COSTING_BULK_UPLOAD ||
                location.pathname === COSTING_SUMMARY ||
                location.pathname === SIMULATION_APPROVAL_SUMMARY_PATH ||
                location.pathname === DASHBOARD_PATH ||
                location.pathname === DASHBOARD_PATH_SECOND ||
                location.pathname === DASHBOARDWITHGRAPH_PATH ||
                location.pathname === SIMULATION_PATH ||
                location.pathname === SIMULATION_HISTORY_PATH ||
                location.pathname === USER_PATH ||
                location.pathname === RFQ_LISTING ||
                location.pathname === PRODUCT_ROLLOUT ||
                location.pathname === NEW_REQUEST_HISTORY ||
                location.pathname === ALL_SUPPLIER ||
                location.pathname !== SUPPLIER_REQUEST_HISTORY ||
                location.pathname !== VIEW_NEW_REQUEST_HISTORY ||
                location.pathname !== ADD_VENDOR_NEED_FORM ||
                location.pathname !== PENDING_FOR_APPROVAL_URL ||
                location.pathname !== ASSESMENT_MASTER_LISTING ||
                location.pathname !== NON_REGISTERED_SUPPLIER_DETAILS ||
                location.pathname !== VENDOR_NEED_FORM ||
                location.pathname === NFR_LISTING ||
                location.pathname === BUSINESS_TYPE_LIST ||
                location.pathname === SPECIALIZATION_LIST ||
                location.pathname === ADD_SPECIALIZATION_LIST ||
                location.pathname === ADD_SUPPLIER ||
                location.pathname === VIEW_SUPPLIER_VENDOR_NEED_FORM || */
        location.pathname === ADD_SPECIALIZATION_LIST ||
        location.pathname === BUSINESS_TYPE_LIST ||
        location.pathname === APPROVAL_LISTING_PATH ||
        location.pathname === APPROVAL_SUMMARY_PATH ||
        location.pathname === COSTING_BULK_UPLOAD ||
        location.pathname === COSTING_SUMMARY ||
        location.pathname === SIMULATION_APPROVAL_SUMMARY_PATH ||
        location.pathname === PENDING_FOR_APPROVAL_SUPPLIER ||
        location.pathname === DASHBOARD_PATH ||
        location.pathname === DASHBOARD_PATH_SECOND ||
        location.pathname === DASHBOARDWITHGRAPH_PATH ||
        location.pathname === SIMULATION_PATH ||
        location.pathname === SIMULATION_HISTORY_PATH ||
        location.pathname === USER_PATH ||
        location.pathname === RFQ_LISTING ||
        location.pathname === PRODUCT_ROLLOUT ||
        location.pathname === NEW_REQUEST_HISTORY ||
        location.pathname === ASSIGN_CFT ||
        location.pathname === NSA_LIST ||
        location.pathname === ALL_SUPPLIER ||
        location.pathname === EXCEPTION_APPROVAL_MENU ||
        location.pathname !== SUPPLIER_REQUEST_HISTORY ||
        location.pathname !== VIEW_NEW_REQUEST_HISTORY ||
        location.pathname !== ADD_VENDOR_NEED_FORM ||
        location.pathname !== PENDING_FOR_APPROVAL_URL ||
        location.pathname !== ASSESMENT_MASTER_LISTING ||
        location.pathname !== SNF_APPROVAL_WORK_FLOW ||
        location.pathname !== NON_REGISTERED_SUPPLIER_DETAILS ||
        location.pathname !== VENDOR_NEED_FORM ||
        location.pathname !== PENDING_FOR_APPROVAL_SUPPLIER ||
        location.pathname === NFR_LISTING ||
        location.pathname === SPECIALIZATION_LIST ||
        location.pathname === ADD_SUPPLIER ||
        location.pathname === ASSIGN_CFT ||
        location.pathname === PENDING_AUDIT_LIST ||
        location.pathname === ADD_ASSESMENT_QUESTION ||
        location.pathname === ADD_BUSINESS_TYPE ||
        location.pathname === ADD_AUDIT_PERSON ||
        location.pathname === SUPPLIER_MANAGEMENT ||
        location.pathname === NFR_LISTING ||
        location.pathname === AUCTION_LISTING ||
        location.pathname === ADD_AUCTION
        ? "w-100"
        : "";

    //  ADD DASHBPOARD CLASS FOR DASHBOARD PAGE ONLY
    const DashboardPage =
      location.pathname === DASHBOARDWITHGRAPH_PATH ? "Dashboard-page" : "";
    const DashboardMainPage =
      location.pathname === DASHBOARD_PATH ||
        location.pathname === DASHBOARD_PATH_SECOND ||
        location.pathname === PRODUCT_ROLLOUT ||
        location.pathname === NEW_REQUEST_HISTORY
        ? "Dashboard-page"
        : "";
    //  ADD DASHBPOARD CLASS FOR DASHBOARD PAGE ONLY

    return (
      <Suspense fallback={<Loader />}>
        {this.state.isLoader && <Loader />}
        <div className="">
          {!this.state.visibelPageNotFound && isLogin && (
            <div className="sf-mainwrapper">
              <div className=" sf-mainheader">
                <div className="container-fluild header-menu">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="inner-header main-menu">
                        <Route
                          path="/"
                          render={(props) => (
                            <SideBar
                              {...props}
                              isUserLoggedIn={this.props.isUserLoggedIn}
                              logUserIn={this.props.logUserIn}
                              logUserOut={this.props.logUserOut}
                              breadCrumbTrail={this.breadCrumbTrail}
                            />
                          )}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          <div className={isLogin ? "blue-box" : ""}>
            <div className={isLogin ? "main-section" : ""}>
              {isLogin &&
                !this.state.visibelPageNotFound &&
                location.pathname !== COSTING_PATH &&
                location.pathname !== APPROVAL_SUMMARY_PATH &&
                location.pathname !== APPROVAL_LISTING_PATH &&
                location.pathname !== COSTING_BULK_UPLOAD &&
                location.pathname !== COSTING_SUMMARY &&
                location.pathname !== DASHBOARDWITHGRAPH_PATH &&
                location.pathname !== SIMULATION_APPROVAL_SUMMARY_PATH &&
                location.pathname !== DASHBOARD_PATH &&
                location.pathname !== DASHBOARD_PATH_SECOND &&
                location.pathname !== SIMULATION_PATH &&
                location.pathname !== SIMULATION_HISTORY_PATH &&
                location.pathname !== USER_PATH &&
                location.pathname !== RFQ_LISTING &&
                location.pathname !== AUCTION_LISTING &&
                location.pathname !== NFR_LISTING &&
                location.pathname !== PRODUCT_ROLLOUT &&
                location.pathname !== NEW_REQUEST_HISTORY &&
                location.pathname !== ANNUAL_KYS_UPDATES_LIST &&
                location.pathname !== MASTER_UPDATE &&
                location.pathname !== UPDATE_UNBLOCKING_REQUEST &&
                location.pathname !== ANUUAL_KYS_REQUEST_DETAIL &&
                location.pathname !== ANNUAL_KYS_REQUEST_LIST &&
                location.pathname !== VENDOR_UNBLOCKING_REQUEST_LIST &&
                location.pathname !== MASTER_UPDATE_REQUEST_LIST &&
                location.pathname !== ASSIGN_CFT &&
                location.pathname !== NSA_LIST &&
                location.pathname !== PENDING_AUDIT_LIST &&
                location.pathname !== PENDING_FOR_APPROVAL_KYS2_LIST &&
                location.pathname !== ALL_SUPPLIER &&
                location.pathname !== EXCEPTION_APPROVAL_MENU &&
                location.pathname !== SUPPLIER_REQUEST_HISTORY &&
                location.pathname !== VIEW_NEW_REQUEST_HISTORY &&
                location.pathname !== ADD_VENDOR_NEED_FORM &&
                location.pathname !== NON_REGISTERED_SUPPLIER_DETAILS &&
                // location.pathname !== BUSINESS_TYPE_LIST &&
                // location.pathname !== SPECIALIZATION_LIST &&
                // location.pathname !== BUSINESS_TYPE_LIST &&
                // location.pathname !== LEGAL_DOCUMENT &&
                location.pathname !== SPECIALIZATION_LIST &&
                location.pathname !== MASTER_UPDATE_REQUEST_DETAIL_VIEW &&
                location.pathname !== MASTER_UPDATE_REQUESTS &&
                location.pathname !== ADD_SPECIALIZATION_LIST &&
                location.pathname !== ADD_BUSINESS_TYPE &&
                // location.pathname !== ASSESMENT_MASTER_LISTING &&
                location.pathname !== PENDING_FOR_APPROVAL_URL &&
                location.pathname !== PENDING_FOR_APPROVAL_SUPPLIER &&
                location.pathname !== ADD_SUPPLIER &&
                location.pathname !== VIEW_SUPPLIER_VENDOR_NEED_FORM &&
                location.pathname !== SNF_APPROVAL_WORK_FLOW &&
                // location.pathname !== ADD_AUDIT_PERSON &&
                location.pathname !== VENDOR_NEED_FORM &&
                location.pathname !== SUPPLIER_MANAGEMENT &&
                location.pathname !== lOGIN_AUDITS &&
                location.pathname !== SUPPLIER_APPROVAL_SUMMARY &&
                location.pathname !== ADD_AUCTION && (
                  <LeftMenu {...this.props} />
                )}

              <div
                className={
                  isLogin
                    ? `content-page ${fullSizeClass} ${DashboardPage} ${DashboardMainPage}`
                    : ""
                }
              >
                <div className={`${isLogin ? `middleContainer` : ""}`}>
                  <Switch>
                    <Route
                      exact
                      path="/"
                      component={AuthMiddleware(Dashboard, DASHBOARD)}
                    />

                    <Route
                      path="/login"
                      render={(props) => (
                        <Login
                          {...props}
                          isUserLoggedIn={this.props.isUserLoggedIn}
                          logUserIn={this.props.logUserIn}
                        />
                      )}
                    />

                    <Route
                      path="/users"
                      component={AuthMiddleware(User, USER)}
                    />

                    <Route path="/forget-password" component={ResetPassword} />

                    <Route
                      path="/dashboard"
                      component={AuthMiddleware(Dashboard, DASHBOARD)}
                    />

                    <Route
                      path="/dashboardWithGraph"
                      component={AuthMiddleware(DashboardWithGraph, DASHBOARD)}
                    />

                    <Route
                      path="/part-master"
                      component={AuthMiddleware(PartMaster, PART)}
                    />

                    <Route
                      path="/UOM-Master"
                      component={AuthMiddleware(UOMMaster, UOM)}
                    />

                    <Route
                      path="/raw-material-master"
                      exact
                      component={AuthMiddleware(
                        RowMaterialMaster,
                        RAW_MATERIAL
                      )}
                    />

                    <Route
                      path="/raw-material-master/raw-material-approval"
                      component={AuthMiddleware(CommonApproval, RAW_MATERIAL)}
                    />

                    <Route
                      path="/plant-master"
                      component={AuthMiddleware(PlantMaster, PLANT)}
                    />

                    <Route
                      path="/vendor-master"
                      component={AuthMiddleware(VendorMaster, VENDOR)}
                    />

                    <Route
                      path="/bop-master"
                      component={AuthMiddleware(BOPMaster, BOP)}
                    />

                    <Route
                      path="/fuel-master"
                      component={AuthMiddleware(FuelMaster, FUEL_AND_POWER)}
                    />

                    <Route
                      path="/machine-master"
                      component={AuthMiddleware(MachineMaster, MACHINE)}
                    />

                    <Route
                      path="/operation-master"
                      component={AuthMiddleware(OperationsMaster, OPERATION)}
                    />

                    <Route
                      path="/freight-master"
                      component={AuthMiddleware(FreightMaster, FREIGHT)}
                    />

                    <Route
                      path="/labour-master"
                      component={AuthMiddleware(LabourListing, LABOUR)}
                    />

                    <Route
                      path="/overhead-profits-master"
                      component={AuthMiddleware(
                        OverheadProfit,
                        OVERHEAD_AND_PROFIT
                      )}
                    />

                    <Route
                      path="/interest-rate-master"
                      component={AuthMiddleware(InterestRate, INTEREST_RATE)}
                    />

                    <Route
                      path="/costing"
                      component={CostingRoutes}
                      exact={true}
                    />
                    <Route
                      path="/costing-summary"
                      component={AuthMiddleware(CostingForm, COSTING_SUMMARY_)}
                    />

                    {/* <Route path="/approval-summary" component={AuthMiddleware(ApprovalSummary, Approval_Summary)} /> */}
                    <Route
                      path="/approval-summary"
                      component={AuthMiddleware(ApprovalSummary, APPROVAL_APP)}
                    />

                    <Route
                      path="/approval-listing"
                      component={AuthMiddleware(CostingForm, APPROVAL_APP)}
                    />
                    {/* <Route path="/approval-listing" component={AuthMiddleware(ApprovalListing,Approval_Listing)} /> */}

                    <Route
                      path="/costing-bulkUpload"
                      component={AuthMiddleware(
                        CostingSummaryBulkUpload,
                        COSTING_BULKUPLOAD
                      )}
                    />

                    <Route
                      path="/reason-master"
                      component={AuthMiddleware(ReasonListing, REASON)}
                    />

                    <Route
                      path="/volume-master"
                      component={AuthMiddleware(VolumeListing, VOLUME)}
                    />

                    <Route
                      path="/client-master"
                      component={AuthMiddleware(ClientMaster, CLIENT)}
                    />

                    <Route
                      path="/exchange-master"
                      component={AuthMiddleware(
                        ExchangeRateListing,
                        EXCHANGE_RATE
                      )}
                    />

                    <Route
                      path="/tax-master"
                      component={AuthMiddleware(TaxListing, TAX)}
                    />

                    {/* <Route path="/simulation-history" component={AuthMiddleware(SimulationHistory, Simulation_History)} /> */}

                    {/* <Route path="/simulation-history" component={SimulationHistory} /> */}
                    <Route
                      path="/simulation-history"
                      component={AuthMiddleware(
                        SimulationForm,
                        Simulation_Page
                      )}
                    />

                    <Route
                      path="/simulation-approval-summary"
                      component={AuthMiddleware(
                        SimulationApprovalSummary,
                        Simulation_Page
                      )}
                    />
                    <Route
                      path="/simulation"
                      component={SimulationRoutes}
                      exact={true}
                    />
                    <Route
                      path="/simulation-upload"
                      component={AuthMiddleware(
                        SimulationUpload,
                        Simulation_Upload
                      )}
                    />
                    <Route
                      path="/costing-breakup-report"
                      component={AuthMiddleware(
                        CostingDetailReport,
                        COSTING_BREAKUP_DETAILS_REPORT
                      )}
                    />
                    <Route
                      path="/cost-ratio-report"
                      component={AuthMiddleware(
                        CostRatioReport,
                        COST_RATIO_REPORT
                      )}
                    />
                    <Route
                      path="/master-benchmarking-report"
                      component={AuthMiddleware(
                        CostingBenchmarkReport,
                        MASTER_BENCHMARK_REPORT
                      )}
                    />
                    <Route
                      path="/cost-movement-report"
                      component={AuthMiddleware(
                        CostMovementReport,
                        COST_MOVEMENT_REPORT
                      )}
                    />
                    <Route
                      path="/master-cost-movement-report"
                      component={AuthMiddleware(
                        MasterCostMovement,
                        MASTER_COST_MOVEMENT_REPORT
                      )}
                    />
                    <Route
                      path="/supplier-contribution-report"
                      component={AuthMiddleware(
                        SupplierContributionReport,
                        SUPPLIER_CONTRIBUTION_REPORT
                      )}
                    />
                    <Route
                      path="/sale-provision-report"
                      component={AuthMiddleware(
                        SaleProvisionReport,
                        SALE_PROVISION_REPORT
                      )}
                    />
                    <Route
                      path="/purchase-provision-report"
                      component={AuthMiddleware(
                        PurchaseProvisionReport,
                        PURCHASE_PROVISION_REPORT
                      )}
                    />
                    <Route
                      path="/customer-poam-summary-report"
                      component={AuthMiddleware(
                        CustomerPoamSummaryReport,
                        CUSTOMER_POAM_REPORT
                      )}
                    />
                    <Route
                      path="/head-wise-costing-got-given"
                      component={AuthMiddleware(
                        HeadWiseCostingGotGiven,
                        HEAD_WISE_COSTING_GOT_GIVEN
                      )}
                    />
                    <Route
                      path="/plant-head-wise"
                      component={AuthMiddleware(
                        PlantWiseCostingGotGiven,
                        PLANT_HEAD_WISE
                      )}
                    />
                    <Route path="/pipd-report" component={PipdReport} />
                    <Route path="/product-rollout" component={ProductRollout} />
                    {/*  NEED TO ADD PATH FROM BACKEND */}
                    <Route
                      path="/simulation-insights"
                      component={AuthMiddleware(
                        SimulationInsights,
                        INSIGHT_SIMULATION_REPORT
                      )}
                    />
                    <Route
                      path="/rfq-listing"
                      component={AuthMiddleware(RfqListing, RFQ)}
                    />
                    <Route
                      path="/nfr"
                      component={AuthMiddleware(NfrTabs, NFR)}
                    />
                    <Route
                      path="/budgeting"
                      component={AuthMiddleware(BudgetMaster, BUDGETING)}
                    />
                    <Route
                      path="/got-given-summary-details-report"
                      component={GotGivenReport}
                    />
                    <Route
                      path="/out-sourcing-master"
                      component={AuthMiddleware(
                        OutsourcingListing,
                        OUTSOURCING
                      )}
                    />
                    {/* Supplier Repository */}
                    <Route path="/sap-push-detail" component={SAPDetailList} />
                    <Route
                      path="/nfr-insights-details"
                      component={AuthMiddleware(
                        NFRInsightsReport,
                        NFR_INSIGHT_DETAILS
                      )}
                    />
                    <Route
                      path="/login-audit"
                      component={AuthMiddleware(LoginAudit, lOGIN_AUDIT)}
                    />
                    <Route
                      path="/supplier-list-all"
                      component={AuthMiddleware(
                        SupplierOnboardingPermission,
                        ALL_SUPPLIER_PAGE
                      )}
                    />
                    <Route
                      path="/new-request-history"
                      component={AuthMiddleware(
                        SupplierRequestHistoryList,
                        NEW_SUPPLIER_REQUEST
                      )}
                    />
                    <Route
                      path="/business-type-list"
                      component={AuthMiddleware(
                        BuisnessTypePermission,
                        BUISNESS_TYPE_PAGE
                      )}
                    ></Route>
                    <Route
                      path="/nfr-insights-details"
                      component={AuthMiddleware(
                        NFRInsightsReport,
                        NFR_INSIGHT_DETAILS
                      )}
                    />
                    <Route
                      path="/login-audit"
                      component={AuthMiddleware(LoginAudit, lOGIN_AUDIT)}
                    />
                    <Route
                      path="/initiate-unblocking"
                      component={AuthMiddleware(
                        VendorManagement,
                        INITIATE_UNBLOCKING
                      )}
                    />
                    {/* <Route path="/lps-rating" component={AuthMiddleware(LpsRatingListing, LPS_RATING)} /> */}
                    <Route
                      path="/supplier-approval-summary"
                      component={(CommonApproval, APPROVAL_LISTING)}
                    />
                    <Route
                      path="/initiate-unblocking"
                      component={AuthMiddleware(
                        InitiateUnblocking,
                        INITIATE_UNBLOCKING
                      )}
                    />
                    {/* <Route path='/supplier-approval-summary' component={SummaryDrawer} /> */}
                    {/* <Route path='/initiate-unblocking/vendor-classification' component={UnblockClassification} />
                    <Route path='/initiate-unblocking/vendor-lps' component={UnblockClassificationLps} />
                    <Route path='/initiate-unblocking/lps-rating' component={UnblockLPSRating} /> */}

                    <Route
                      path="/specialization-list"
                      component={AuthMiddleware(
                        Specialization,
                        SPECIALIZATION_PAGE
                      )}
                    ></Route>
                    <Route
                      path="/add-payment-terms"
                      component={AuthMiddleware(
                        PaymentTermsMaster,
                        ADD_PAYMENT_TERMS
                      )}
                    ></Route>
                    <Route
                      path="/account-group-master"
                      component={AuthMiddleware(
                        AccountGroupMaster,
                        ACCOUNT_GROUP_MASTER
                      )}
                    ></Route>
                    {/* <Route
                      path="/supplier-request-history"
                      component={AuthMiddleware(
                        SupplierRequestHistoryListing,
                        APPROVAL_HISTORY
                      )}
                    /> */}
                    <Route
                      path="/master-update-requests"
                      component={AuthMiddleware(
                        MasterUpdateRequests,
                        MASTER_UPDATE_REQUESTS
                      )}
                    ></Route>
                    <Route
                      path="/master-update-requests-detail"
                      component={AuthMiddleware(
                        MasterUpdateRequestsDetail,
                        MASTER_UPDATE_REQUESTS
                      )}
                    ></Route>
                    <Route
                      path="/annual-kys-requests"
                      component={AuthMiddleware(
                        AnnualKysRequests,
                        ANNUAL_KYS_REQUEST
                      )}
                    ></Route>
                    <Route
                      path="/annual-kys-requests-detail"
                      component={AuthMiddleware(
                        AnnualKysRequestsDetail,
                        ANNUAL_KYS_REQUEST

                      )}
                    ></Route>
                    <Route
                      path="/annual-kys-updates"
                      component={AuthMiddleware(
                        AnnualKYSUpdates,
                        ANNUAL_KYS_UPDATES
                      )}
                    ></Route>
                    <Route
                      path="/supplier-unblocking-request"
                      component={AuthMiddleware(
                        SupplierUnblockingRequest,
                        VENDOR_UNBLOCKING
                      )}
                    ></Route>
                    <Route
                      path="/repository-dashboard"
                      component={AuthMiddleware(
                        RepositoryReportDashboard,
                        REPOSITORY_DASHBOARD
                      )}
                    ></Route>

                    <Route
                      path="/supplier-onboarding-dashboard"
                      component={AuthMiddleware(
                        SupplierOnboardingDashboardReport,
                        SUPPLIER_ONBOARDING_DASHBOARD_REPORT
                      )}
                    ></Route>
                    <Route
                      path="/detailed-tracking-report-L1"
                      component={AuthMiddleware(
                        DetailTrackingReportL1,
                        DETAIL_TRACKING_REPORT_L1
                      )}
                    ></Route>
                    <Route
                      path="/detailed-tracking-report-L2"
                      component={AuthMiddleware(
                        DetailTrackingReportL2,
                        DETAIL_TRACKING_REPORT_L2
                      )}
                    ></Route>
                    <Route
                      path="/application-tracker-dates"
                      component={AuthMiddleware(
                        ApplicationTrackerDatesReport,
                        APPLICATION_TRACKER_DATES_REPORT
                      )}
                    ></Route>
                    <Route
                      path="/exception-dashboard"
                      component={AuthMiddleware(
                        ExceptionDashboardReport,
                        EXCEPTION_DASHBOARD
                      )}
                    ></Route>
                    <Route
                      path="/exception-drilldown"
                      component={AuthMiddleware(
                        ExceptionDrillDownReport,
                        EXCEPTION_DRILLDOWN

                      )}
                    ></Route>
                    <Route
                      path="/pending-approval-drilldown-report"
                      component={AuthMiddleware(
                        PendingApprovalDrillDownReport,
                        PENDING_APPROVAL_DRILLDOWN_REPORT

                      )}
                    ></Route>
                    <Route
                      path="/nsa-drilldown-report"
                      component={AuthMiddleware(
                        NSADrillDownReport,
                        NSA_DRILLDOWN_REPORT

                      )}
                    ></Route>
                    <Route
                      path="/kys-updates-dashboard"
                      component={AuthMiddleware(
                        KYSUpdateDashboardReport,
                        KYS_UPDATES_DASHBOARD

                      )}
                    ></Route>
                    <Route
                      path="/kys-update-drilldown"
                      component={AuthMiddleware(
                        KYSUpdateDrillDownReport,
                        KYS_UPDATES_DRILLDOWN

                      )}
                    ></Route>
                    <Route
                      path="/master-update-dashboard"
                      component={AuthMiddleware(
                        MasterUpdateDashboardReport,
                        MASTER_UPDATE_DASHBOARD
                      )}
                    ></Route>
                    <Route
                      path="/supplier-unblocking-dashboard"
                      component={AuthMiddleware(
                        SupplierUnblockingDashboardReport,
                        SUPPLIER_UNBLOCKING_DASHBOARD
                      )}
                    ></Route>
                    <Route
                      path="/master-update-drilldown"
                      component={AuthMiddleware(
                        MasterUpdateDrillDownReport,
                        MASTER_UPDATE_DRILLDOWN
                      )}
                    ></Route>
                    <Route
                      path="/view-new-request-history"
                      component={AuthMiddleware(
                        ViewNewRequestHistory,
                        NEW_SUPPLIER_REQUEST
                      )}
                    />
                    <Route
                      path="/supplier-need-approval-summary"
                      component={AuthMiddleware(
                        ViewApprovalSummarySnf,

                      )}
                    />
                    <Route
                      path="/supplier-need-form"
                      component={AuthMiddleware(
                        AddVendorNeed,
                        NEW_SUPPLIER_NEED_FORM
                      )}
                    />
                    <Route
                      path="/update-supplier-unblocking-request"
                      component={AuthMiddleware(
                        AddUnblockingRequest,
                        'Update Supplier Unblocking Request'
                      )}
                    />
                    <Route
                      path="/exception-approval"
                      component={AuthMiddleware(
                        ExceptionApprovalPermission,
                        EXCEPTION_APPROVAL_LIST
                      )}
                    />
                    <Route
                      path="/exception-flow-approval"
                      component={AuthMiddleware(
                        ExceptionFlowApproval,
                        PENDING_FOR_APPROVAL_KYS2_LIST
                      )}
                    />
                    <Route
                      path="/non-registered-supplier-details"
                      component={AuthMiddleware(
                        ViewSupplierDetails,
                        ALL_SUPPLIER_PAGE
                      )}
                    />
                    <Route
                      path="/company-code-master"
                      component={AuthMiddleware(
                        CompanyCodeListMaster,
                        COMPANY_CODE_MASTER
                      )}
                    ></Route>
                    <Route
                      path="/supplier-certificate"
                      component={AuthMiddleware(
                        SupplierCertificateMaster,
                        SUPPLIER_CERTIFICATE
                      )}
                    />
                    <Route
                      path="/legal-document"
                      component={AuthMiddleware(
                        LegalDocument,
                        LEGAL_DOCUMENT_PAGE
                      )}
                    />
                    <Route
                      path="/add-audit"
                      component={AuthMiddleware(AuditListing, AUDIT_PERSON)}
                    />
                    {/* Vendor Need Form */}
                    <Route
                      path="/vendor-need-list"
                      component={AuthMiddleware(
                        VendorOnboaringPermission,
                        ALL_NEED_FORM
                      )}
                    />
                    <Route
                      path="/pending-for-approval"
                      component={AuthMiddleware(
                        PendingList,
                        PENDING_FOR_APPROVAL_PAGE
                      )}
                    />
                    {/*Assesment Master222 */}
                    <Route
                      path="/assessment-master"
                      component={AuthMiddleware(Assesment, ASSESSMENT_PAGE)}
                    ></Route>

                    <Route
                      path="/account-group-mapping-master"
                      component={AuthMiddleware(
                        AccountGroupMappingListMaster,
                        ACCOUNT_GROUP_MAPPING_MASTER
                      )}
                    ></Route>
                    <Route
                      path="/reconciliation-account-master"
                      component={AuthMiddleware(
                        ReconciliationListMaster,
                        RECONCILIATION_MASTER
                        //  ACCOUNT_RECONCILIATION_MASTER
                      )}
                    ></Route>

                    <Route
                      path="/email-tracking"
                      component={AuthMiddleware(
                        EmailTrackMaster,
                        EMAIL_TRACKING
                      )}
                    ></Route>
                    <Route
                      path="/soc-code-master"
                      component={AuthMiddleware(
                        SocListMaster,
                        SOC_CODE_MASTER_ADDITIONAL
                        // EMAIL_TRACKING
                      )}
                    ></Route>
                    <Route
                      path="/view-supplier-need-form"
                      component={AuthMiddleware(
                        AssesmentForm,
                        ALL_NEED_FORM
                      )}
                    ></Route>
                    <Route
                      path="/pending-for-approval-kys2"
                      component={AuthMiddleware(
                        PendingListKy2,
                        PENDING_FOR_APPROVAL_KYS2_LIST
                      )}
                    ></Route>
                    {/* NSA  */}
                    <Route
                      path="/nsa-list"
                      component={AuthMiddleware(NsaListingPermission, NSA_LIST_PAGE)}
                    ></Route>
                    <Route
                      path="/pending-audit"
                      component={AuthMiddleware(
                        PendingAuditList,
                        PENDING_AUDIT_LIST_PAGE
                      )}
                    ></Route>
                    <Route
                      path="/assign-cft"
                      component={AuthMiddleware(AssignCfts)}
                    ></Route>
                    {/*Assesment Master */}
                    <Route path='/vendor-classification' component={AuthMiddleware(VendorClassificationListing, VENDOR_MANAGEMENT)} />
                    <Route path='/lps-rating' component={AuthMiddleware(LpsRatingListing, LPS)} />
                    <Route path='/material-indexation' component={AuthMiddleware(Indexation, INDEXATION,)} />


                    <Route path="/reverse-auction" component={AuctionIndex} />
                    <Route path="/add-auction" component={AddAuction} />
                    <Route path="/audit-trail" component={AuditTrailTab} />

                    {/* <Route path='/simulation-approval-listing' component={SimulationApprovalListing} /> */}

                    {/* <Route path="/product-master" component={productMaster} /> */}

                    <Route
                      render={(props) => (
                        <NotFoundPage
                          {...props}
                          isLoggeIn={false}
                          handlePageNotFound={this.handlePageNotFound}
                          hidePageNotFound={this.hidePageNotFound}
                        />
                      )}
                    />
                  </Switch >
                </div >
              </div >
            </div >
          </div >
          {!this.state.visibelPageNotFound && (
            <div>
              <Route path="/" component={Footer} />
            </div>
          )
          }
          <ReduxToastr
            timeOut={2500}
            newestOnTop={false}
            preventDuplicates
            position="top-right"
            transitionIn="fadeIn"
            transitionOut="fadeOut"
            // transitionIn="bounceIn"
            // transitionOut="bounceOut"
            progressBar
          />

          <ToasterBoXWrapper />

          {this.handleUserData()}
        </div >
      </Suspense >
    );
  }
}

/**
 * @method connect
 * @description connect with redux
 * @param {function} mapStateToProps
 * @param {function} mapDispatchToProps
 */
export default connect(null, { showUserData, TokenAPI, AutoSignin })(Main);
